import React from 'react';
import { fetchCourse } from '../services/options_service';
import InputSelectAsync from './InputSelectAsync';

const CourseInputAsync = ({ placeholderOption, ...props }) => (
  <InputSelectAsync
    defaultOptions
    label="Curso:"
    name="course"
    placeholder="Curso"
    loadOptions={(search) => fetchCourse({search})}
    getOptionLabel={(d) => d.name}
    getOptionValue={(d) => d.id}
    {...props}
  />
);

export default CourseInputAsync;
